// The admin (sudo) account an endpoint is set up through — the check both the
// Add Endpoint form and "Update admin credential…" run before calling
// adminCredential. It mirrors the server's validateAdmin / validAccountName
// (internal/pam/handler/instances/admin.go, accounts.go) rule for rule, so the
// form neither refuses a name the server would take nor lets one through that
// it would reject.

// Accounts the server refuses as the admin account.
const RESERVED = ["authnull-svc", "nobody"];

// What validAccountName allows: letters (either case), digits, ".", "_", "-".
const ACCOUNT_CHARS_RE = /^[A-Za-z0-9._-]*$/;

// The server measures the length in bytes.
const byteLength = (s) => new TextEncoder().encode(s).length;

// Why `raw` can't be the admin username with `method` ("password" | "key"),
// or "". Without a method the root-needs-a-key rule is not applied.
export function adminUsernameError(raw, method) {
  const name = String(raw || "").trim();
  if (!name) return "Enter the account's username.";
  if (name.includes("@")) return "The username can't contain “@” (ssh reads it as the host separator).";
  if (byteLength(name) > 32) return "The username can be at most 32 characters.";
  if (name.startsWith("-")) return "The username can't start with “-”.";
  if (!ACCOUNT_CHARS_RE.test(name)) return "Use letters, digits, “.”, “_” and “-”.";
  if (RESERVED.includes(name)) return `${name} can't be the admin account.`;
  if (method === "password" && name === "root") return "root can only be used with a private key.";
  return "";
}

// How long to wait before the next setup-status read, `elapsedMs` into a
// round of polling: every 3 s for the first minute, then every 10 s, then
// every 30 s once five minutes have passed. A Retry starts a new round.
export function setupPollDelay(elapsedMs) {
  if (elapsedMs < 60 * 1000) return 3000;
  if (elapsedMs < 5 * 60 * 1000) return 10 * 1000;
  return 30 * 1000;
}
